module.exports = __webpack_public_path__ + "img/icon_map_sf.b8e1610d.png";